import React from "react";
import { Subscription } from "react-apollo";
import { httpClient } from "settings/apolloClient";
import {
  CURRENT_AUTOMATION_STATUS_QUERY,
  SUBSCRIBE_TO_AUTOMATION_STATUS,
} from "views/AutomationStatus/automationStatusQueries";

// Keeps the automation status live for the whole session by writing each change
// into the httpClient cache; panels (InstrumentsPanel) only read that cache.
//
// This must be mounted somewhere that survives route navigation (the Admin
// layout), NOT inside a page. When the subscription lived inside InstrumentsPanel
// it was torn down and recreated on every tab switch, and the second mount hit
// the @absinthe/socket resubscribe race: `send` finds the still-`canceling`
// notifier and reactivates it without re-pushing, so the client believes it is
// subscribed while the server has no subscription — the status froze and only
// the cache-and-network refetch on mount updated it once. Mounting the
// subscription once means the notifier is never canceled during navigation, so
// the race never triggers.
const AutomationStatusSubscriber = () => (
  <Subscription
    subscription={SUBSCRIBE_TO_AUTOMATION_STATUS}
    fetchPolicy="no-cache"
    onSubscriptionData={({ subscriptionData }) => {
      const status = subscriptionData
        && subscriptionData.data
        && subscriptionData.data.subscribeToAutomationStatus;

      if (!status) return;

      httpClient.writeQuery({
        query: CURRENT_AUTOMATION_STATUS_QUERY,
        data: { currentAutomationStatus: status },
      });
    }}
  >
    {() => null}
  </Subscription>
);

export default AutomationStatusSubscriber;
